import React from 'react';
import './ResponsePage.css';
import successIcon from '../img/success-check.png';
import errorIcon from '../img/failed-eerror.png';

const ResponsePage = ({ dob, age, error, message, errorType, onRetake }) => {
  const showRetryButton = errorType === 'blurry_document' || errorType === 'face_not_detected';

  return (
    <div className="response-container">
      <div className="response-content">
        {error ? (
          <>
            <img src={errorIcon} alt="Error" className="response-illustration" />
            <h2 className="error-text">Verification Failed</h2>
            <p className="message">{message}</p>

            
                <p className="suggestion">
                  Please capture images with better lighting and clarity.
                </p>
                <button className="restart-btn" onClick={onRetake}>
                  Retake Images
                </button>
             
          </>
        ) : (
          <>
            <img src={successIcon} alt="Success" className="response-illustration" />
            <h2>Verification Successful!</h2>
            <p className="message">Your identity has been verified successfully.</p>
            {/* <div className="result-box">
              <p><strong>Date of Birth:</strong> {dob}</p>
              <p><strong>Age:</strong> {age}</p>
            </div> */}
            <button className="restart-btn" onClick={() => window.location.reload()}>
              Start Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ResponsePage;
